export default __webpack_public_path__ + "static/media/cardimg3.fbb93c1a.png";